/**
 * custom-cart-upsell.js
 * =====================
 * Pfeile und "Hinzufügen" für die Vorschläge im Warenkorb-Slideout
 * (snippets/custom-cart-upsell.liquid).
 *
 * Alles über Delegation am Dokument: Die Vorschläge werden per fetch
 * nachgeladen und das Slideout bei jeder Warenkorb-Änderung über innerHTML
 * ersetzt. Handler, die direkt an den Elementen hängen, wären danach weg.
 */
(function () {
  'use strict';

  // Dieselben Abschnitte, die auch das Theme nach einem Hinzufuegen neu
  // rendert – sonst blieben Warenkorbseite oder Zaehler im Header stehen.
  var SECTIONS = [
    { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
    { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function addUrl() {
    return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
  }

  /* ── Pfeile ───────────────────────────────────────────────────────────── */

  function step(root, direction) {
    var track = root.querySelector('[data-upsell-track]');
    if (!track) return;

    var width = track.clientWidth || 1;
    // Auf ein Vielfaches der Kartenbreite runden: Nach einem Wisch steht die
    // Ansicht sonst zwischen zwei Karten und der Pfeil spraenge nur halb weiter.
    var current = Math.round(track.scrollLeft / width);
    var target = Math.max(0, Math.min(current + direction, track.children.length - 1));

    track.scrollTo({ left: target * width, behavior: 'smooth' });
  }

  /* ── Hinzufügen ───────────────────────────────────────────────────────── */

  function sectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsed ? parsed.innerHTML : null;
  }

  function render(state) {
    SECTIONS.forEach(function (section) {
      var host = document.getElementById(section.id);
      if (!host || !state.sections || !state.sections[section.section]) return;

      var markup = sectionInnerHTML(state.sections[section.section], section.selector);
      if (markup === null) return;

      // Das Theme verschachtelt den Selektor nicht immer – trifft er innen
      // nicht, wird der Behaelter selbst gefuellt.
      var target = host.querySelector(section.selector) || host;
      target.innerHTML = markup;
    });

    // Das Theme haengt seine Warenkorb-Handler an frische Instanzen. Cart gibt
    // es nur auf der Warenkorbseite, CartDrawer ueberall.
    if (typeof CartDrawer !== 'undefined') new CartDrawer();
    if (typeof Cart !== 'undefined' && document.getElementById('Cart')) new Cart();
  }

  function add(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    body.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
    body.append('sections_url', window.location.pathname);

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status) {
          // Shopify meldet den Grund (z. B. Bestand erschoepft). Den Knopf
          // wieder freigeben, statt stumm haengen zu bleiben.
          btn.classList.remove('is-loading');
          btn.disabled = false;
          var label = btn.querySelector('.custom-cart-upsell__add-label');
          if (label) label.textContent = 'Nicht möglich';
          return;
        }
        render(state);
      })
      .catch(function (error) {
        console.error(error);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  /* ── Bindung ──────────────────────────────────────────────────────────── */

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;

    var prev = target.closest('[data-upsell-prev]');
    var next = target.closest('[data-upsell-next]');
    if (prev || next) {
      var root = (prev || next).closest('[data-custom-cart-upsell]');
      if (root) step(root, prev ? -1 : 1);
      return;
    }

    var addBtn = target.closest('[data-upsell-add]');
    if (addBtn) {
      evt.preventDefault();
      add(addBtn);
    }
  });
})();
